import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'app-info-quest',
  templateUrl: './info-quest.component.html',
  styleUrls: ['./info-quest.component.scss']
})
export class InfoQuestComponent implements OnInit {
  pcForm!: FormGroup;
  quests: any[] = [];
  @Output() dataChange = new EventEmitter<any>();
  @Output() disable = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.getQuest();
    this.initializeForm();
    
    // Subscribe to form changes
    this.pcForm.valueChanges.subscribe((formData) => {
      // console.log('valueChanges',formData);

      let batchCodePass = false;
      if(formData.questBatchCode) {
        if(formData.batchCode.length == formData.bc.length) {
          batchCodePass = true;
        }
      }

      var result = {
        quest: formData.quest,
        questBatchCode: formData.questBatchCode,
        assistantPc: formData.assistantPc,
        batchCodePass: batchCodePass,
        batchCode: formData.batchCode,
        imageUrl: formData.imageUrl
      };
      // console.log('result quest :: ',result)
      this.dataChange.emit(result);
      this.disable.emit(this.checkDisable());
    });
  }

  initializeForm(): void {
    this.pcForm = this.fb.group({
      quest: ['', [Validators.required]],
      questBatchCode: [false],
      assistantPc: ['', [Validators.required]],
      batchCode: [''],
      bc: [''],
      imageUrl: [null],
    });
  }
  
  get f() {
    return this.pcForm.controls;
  }

  async getQuest() {
    this.userService.getQuests({}).subscribe({
      next: (res) => {
        this.quests = res;
      },
      error: (error) => null,
    });
  }

  changeQuest(event: any) {
    console.log(event.target.value);
    var batch = this.quests.find((c: any) => c.id == event.target.value).questAndClinics[0].batchCode;
    if (batch) {
      this.pcForm.get('batchCode')?.setValidators([Validators.required]);
      this.pcForm.get('imageUrl')?.setValidators([Validators.required]);
    } else {
      this.pcForm.get('batchCode')?.clearValidators();
      this.pcForm.get('imageUrl')?.clearValidators();
    }
    this.pcForm.get('batchCode')?.updateValueAndValidity();
    this.pcForm.get('imageUrl')?.updateValueAndValidity();
    this.pcForm.patchValue({
      questBatchCode: batch != '' ? true : false,
      bc: batch,
    });
  }

  // Handle the emitted image file from the child component
  onImageSelected(image: String): void {
    // this.articleForm.get('image')?.setValue(file);
    this.f['imageUrl'].setValue(image);
  }

  checkDisable() {
    if (this.pcForm.valid) {
      return false;
    } else {
      return true;
    }
  }
}
